import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Public marketing landing page at `/`. Redirects to the OreVital dealer
 * storefront so visitors land on the standard one-template page (same
 * header, green brand strip, dark hero, post tabs and featured sidebar).
 */
export default function Landing() {
  const { user } = useAuth();
  if (user) return <Navigate to="/app/earnings" replace />;
  return <Navigate to="/d/orevital?view=home" replace />;
}
